export default __webpack_public_path__ + "static/media/andes_a_la_selva_6.0a93b3a7.JPG";